import React from "react";

const RedemptionPiechartLoader = props => {
    return(
        <div className= "snapshotContainer animated-background lg-width"></div>
    );
}

export default RedemptionPiechartLoader;